<script setup>
import { ref, computed, onMounted } from "vue";
import { useCollection } from "vuefire";
import { collection, query, orderBy } from "firebase/firestore";
import { useStore } from "vuex";
import { watch } from "vue";
import { db } from "@/firebase";
// import Swiper core and required modules
import { Pagination} from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/navigation";
import "swiper/css/pagination";


// Import components and composables
import ItemCardBig from "./components/itemCardBig.vue";

//Swiper modules
const modules = [Pagination];

// Firebase query with sorting by itemNumber
const auctionItemsQuery = query(
  collection(db, "auctionItems"),
  orderBy("itemNumber", "asc") // Sort by itemNumber in ascending order
);

const auctionItems = useCollection(auctionItemsQuery); // Fetch sorted items
const selectedCategory = ref(null);

const store = useStore(); // Access Vuex store


// Computed property for filtered auction items (already sorted by Firestore)
const filteredAuctionItems = computed(() => {
  if (!selectedCategory.value) return auctionItems.value;
  return auctionItems.value.filter(
    (item) => item.categoryId === selectedCategory.value
  );
});

const carouselKey = ref(0);

// Whenever filteredAuctionItems changes, update the key to force re-render
watch(filteredAuctionItems, () => {
  carouselKey.value++;
});
// Lifecycle hooks
onMounted(async () => {
  await store.dispatch("fetchCategories"); // Ensure categories are fetched
});
</script>

<template>
  <div class="layout-main show-all-items">
    <swiper
  ref="mySwiper"
  :modules="modules"
  :lazy="true"
  :slides-per-view="1"
  :slidesPerGroup="1"
  :space-between="10"
  :grid="{ rows: 1, fill: 'row' }"
  :navigation="true"
  :loop="true"
  :pagination="{
    dynamicBullets: true,
    dynamicMainBullets: 18,
    type: 'fraction',
    clickable: true,
   
  }"
  :autoplay="{ delay: 10000, disableOnInteraction: false }"
  :scrollbar="{ draggable: true }"
  @swiper="onSwiper"
  @slideChange="onSlideChange"
  style="--swiper-navigation-size: 20px; --swiper-theme-color: #1b2750;"
>
  <swiper-slide
    v-for="item in filteredAuctionItems"
    :key="item.id"
  >
    <ItemCardBig
      :item="item"
      :getCategoryName="store.getters.getCategoryName"
    />
  </swiper-slide>
</swiper>
  
    
  
</div>
</template>

<style lang="scss">
.show-all-items {
  min-height: 100vh;
}
.show-all-items .p-card-body {
  padding: 0.5rem;
  gap: 0.2rem;
}
@media (max-width: 768px) {
  .show-all-items .col-6 {
    padding: 0rem;
  }
}

@media (max-width: 400px) {
  .itemImage img {
    max-width: 100%;  
  }
}

@media (min-width: 401px) {
  .itemImage img {
    max-width: none;  
  }
}
.swiper-wrapper {
  align-items: center; /* add this will all relevant prefixes */
  padding-bottom: 20px;
  margin-top: -60px;
}
.item-display {
  display: flex;
  align-items: center;
  justify-content: space-between; /* Ensure space between buttons and item */
  position: relative;
  width: 100%;
}

.nav-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px; /* Adjust width as needed */
}

.nav-button {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
}


</style>